export const INDE = "Independent";
